import {html} from 'lit';
import Base from '../base.js';
import styles from './tooltip.css' assert {type: 'css'};

/**
 * @element inv-tooltip
 * @class Tooltip
 * @extends Base
 * @classdesc Tooltip component
 */
export default class Tooltip extends Base {
    constructor() {
        super();
        this.open = false;
    }

    getStyleSheets() {
        return [...super.getStyleSheets(), styles];
    }

    get _tooltipedContent() {
        return this.renderRoot?.querySelector('#tooltiped-content-' + this.getId());
    }

    get _tooltipContent() {
        return this.renderRoot?.querySelector('#tooltip-content-' + this.getId());
    }

    /**
     * @override
     */
    render() {
        return html`
            <div class="tooltip">
                <div id=${'tooltiped-content-' + this.getId()}>
                    <slot name="tooltiped-content"></slot>
                </div>
                <div class="tooltip-content" id=${'tooltip-content-' + this.getId()}>
                    <slot name="tooltip-content"></slot>
                </div>
            </div>
        `;
    }

    firstUpdated() {
        const tooltipedContentElem = this._tooltipedContent;
        const tooltipContentElem = this._tooltipContent;

        const tooltipedSContentStyles = getComputedStyle(tooltipedContentElem);
        const tooltipContentAfterStyles = getComputedStyle(tooltipContentElem, ':after');

        const tooltipedContentWidth = parseFloat(tooltipedSContentStyles.getPropertyValue('width'));
        const tooltipedContentHeight = parseFloat(tooltipedSContentStyles.getPropertyValue('height'));
        const fontSize = parseFloat(tooltipedSContentStyles.getPropertyValue('font-size'));
        const side = parseFloat(tooltipContentAfterStyles.width);
        const leftDistance = parseFloat(tooltipContentAfterStyles.left);

        const tooltipedContentWidthEm = tooltipedContentWidth / fontSize;
        const tooltipedContentHeightEm = tooltipedContentHeight / fontSize;
        const sideEm = side / fontSize;
        const leftDistanceEm = leftDistance / fontSize;

        // the distance from the tirangle vertex and the init of the white dialog is the
        // hypothenuse of the 1.6em side rectangle / 2 that is 1.13em
        // with 1.13 the vertex is conected to the tooltiped content thats why we aument this
        // quantity to 0.2em more to leave a little margin between the tooltip and the tooltiped conten
        const offset = Math.hypot(sideEm, sideEm) / 2;
        tooltipContentElem.style.bottom = tooltipedContentHeightEm + offset + 0.2 + 'em';

        // next value is the function to get the margin to align tooltip to the center
        // of the element tooltiped
        // the 3.13 comes because the dialog triangle (a square rotated 45º)
        // is 2em left from the init + distance to vertex (1.13em because the side of
        // square is 1.6em and its hypotenuse is 2.26em)
        const tooltioMarginLeft = -(leftDistanceEm + offset) + tooltipedContentWidthEm * 0.5;

        tooltipContentElem.style.marginLeft = `${tooltioMarginLeft}em`;
    }
}

Tooltip.register();
